module.exports = __webpack_public_path__ + "media/images/home/permission-5ee25d42701da09e7ac45819eb9f062e.svg";